// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"4e6efb9b","194":"ddd6fdd7","708":"f06a6cc7"}[chunkId] + ".chunk.css";
};